import { get } from 'lodash';
import { getCookie } from '../../../utils';

export const getUserAuthToken = ({ session }) => get(session, 'authToken', getCookie('authToken'));
